export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-stone-900 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-14">
        <div className="flex flex-col md:flex-row items-start justify-between gap-10">
          {/* Brand */}
          <div className="max-w-xs">
            <div className="mb-4">
              <span className="text-amber-300 font-serif text-2xl font-bold">Kevin Hamlett</span>
              <p className="text-stone-500 text-xs tracking-widest uppercase mt-0.5">Author · Soul Line Series</p>
            </div>
            <p className="text-stone-500 text-sm leading-relaxed mb-6">
              Writing at the intersection of nature, consciousness, and the human soul. Published by Leavitt Peak Press.
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: 'ri-amazon-line', label: 'Amazon', href: 'https://www.amazon.com/s?k=Kevin+Hamlett&s=digital-text' },
                { icon: 'ri-twitter-x-line', label: 'Twitter', href: '#' },
                { icon: 'ri-facebook-line', label: 'Facebook', href: '#' },
                { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.href !== '#' ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-amber-500 text-stone-400 hover:text-stone-950 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Nav links */}
          <div className="flex flex-col sm:flex-row gap-10">
            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-widest">Navigate</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Home', href: '#home' },
                  { label: 'About Kevin', href: '#about' },
                  { label: 'The Book', href: '#book' },
                  { label: 'Read an Excerpt', href: '#excerpt' },
                  { label: 'Reviews', href: '#reviews' },
                  { label: 'Contact', href: '#contact' },
                ].map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleNav(link.href)}
                      className="text-sm text-stone-500 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-widest">The Book</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Buy on Amazon (Kindle)', href: 'https://www.amazon.com/dp/B0GT29CWSG' },
                  { label: 'Buy Paperback', href: 'https://www.amazon.com/dp/B0GT29CWSG' },
                  { label: 'Soul Line Series', href: '#book' },
                  { label: 'Leavitt Peak Press', href: '#' },
                ].map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel="noopener noreferrer"
                      className="text-sm text-stone-500 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Buy CTA */}
          <div className="flex flex-col items-start gap-4">
            <div className="p-6 rounded-2xl bg-stone-800 border border-stone-700 text-center min-w-[200px]">
              <p className="text-stone-400 text-xs mb-1">Available Now</p>
              <p className="text-amber-300 font-serif font-bold text-lg mb-1">A River PENETRATING</p>
              <p className="text-stone-400 text-xs mb-4">THE Soul Line: Book #II</p>
              <a
                href="https://www.amazon.com/dp/B0GT29CWSG"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full py-2.5 rounded-full bg-amber-500 hover:bg-amber-400 text-stone-950 font-bold text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-amazon-line"></i>
                Get it — $3.99
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-600">
            &copy; {new Date().getFullYear()} Kevin Hamlett. All rights reserved.
          </p>
          <p className="text-xs text-stone-700">
            Published by Leavitt Peak Press · ISBN 978-1969865374
          </p>
        </div>
      </div>
    </footer>
  );
}
